/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetPinnedRequestBody,
  SetPinnedRequestBody$Outbound,
  SetPinnedRequestBody$outboundSchema,
} from "../components/setpinnedrequestbody.js";

export type SetChatPinnedSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SetChatPinnedRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setPinnedRequestBody: SetPinnedRequestBody;
};

/** @internal */
export type SetChatPinnedSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetChatPinnedSecurity$outboundSchema: z.ZodMiniType<
  SetChatPinnedSecurity$Outbound,
  SetChatPinnedSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setChatPinnedSecurityToJSON(
  setChatPinnedSecurity: SetChatPinnedSecurity,
): string {
  return JSON.stringify(
    SetChatPinnedSecurity$outboundSchema.parse(setChatPinnedSecurity),
  );
}

/** @internal */
export type SetChatPinnedRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetPinnedRequestBody: SetPinnedRequestBody$Outbound;
};

/** @internal */
export const SetChatPinnedRequest$outboundSchema: z.ZodMiniType<
  SetChatPinnedRequest$Outbound,
  SetChatPinnedRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setPinnedRequestBody: SetPinnedRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      setPinnedRequestBody: "SetPinnedRequestBody",
    });
  }),
);

export function setChatPinnedRequestToJSON(
  setChatPinnedRequest: SetChatPinnedRequest,
): string {
  return JSON.stringify(
    SetChatPinnedRequest$outboundSchema.parse(setChatPinnedRequest),
  );
}
